import React, { useState } from 'react';
import {
    Typography,
    CardMedia,
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    Tooltip
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { AddIcon } from 'Shared/Icons';

export const UserIntegrationItemPreDefined = ({ item, linkIntegrationToUser }) => {
  const origin = window.location.origin;
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    if (event.target.classList.contains('PrivateSwitchBase-input')) {
      return;
    }
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Accordion
      sx={{
        marginBottom: '20px',
      }}
      expanded={expanded === 'panel1'}
      onChange={handleChange('panel1')}
    >
      <AccordionSummary
        sx={{
          backgroundColor: '#F2F5F8',
          '& .MuiAccordionSummary-content': {
            alignItems: 'center',
          },
        }}
        expandIcon={
            <Tooltip title={
                <span style={{ fontSize: '1rem', lineHeight: '120%' }}>Details</span>
            } arrow>
                <SettingsIcon/>
            </Tooltip>}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Typography
          variant="h6"
          sx={{
            color: '#3B465C',
            marginRight: '20px',
            flexShrink: 0,
          }}
        >
          {item?.name}
        </Typography>
        <CardMedia
          component="img"
          image={`${origin}${item.logo}`}
          sx={{
            maxWidth: '40px',
            marginRight: '20px',
          }}
        />

        <Typography sx={{ color: 'text.secondary' }}>{item?.description}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Button
          sx={{
            marginTop: '8px',
          }}
          onClick={linkIntegrationToUser}
          startIcon={<AddIcon />}
          variant="outlined"
        >
          Add To My Active Flows
        </Button>
      </AccordionDetails>
    </Accordion>
  );
};
